import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { useMastersContext } from "../../../../contexts/masters.context";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/decoMethodCategoryTableColumns";

function DecoMethodCategoryTable() {
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const { decoMethodCategoryState } = useMastersContext();

  const loadData = async () => {
    await decoMethodCategoryState.fetch();
  };

  useEffect(() => {
    loadData();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => decoMethodCategoryState.data || [], [
    decoMethodCategoryState.data,
  ]);

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Deco Method Category</h4>
        </div>
        <div className="col d-flex justify-content-end">
          {/* <button
            className="btn btn-sm btn-success"
            onClick={() => history.push(`${pathname}/add`)}
          >
            Add New
          </button> */}
        </div>
      </div>
      <hr />
      <CrudTable
        loading={decoMethodCategoryState.loading}
        data={data}
        columns={columns}
        idField="dcM_ID"
        onEdit={(id) => history.push(`${pathname}/edit/${id}`)}
        showDetails={false}
        showEdit={true}
        showRemove={false}
      />
    </div>
  );
}

export default DecoMethodCategoryTable;
